import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, TemplateRef } from '@angular/core';

const toggleArrow = trigger('toggleArrow', [
  state('none', style({ transform: 'rotate(0)' })),
  state('visible', style({ transform: 'rotate(180deg)' })),
  transition('visible => none', animate('200ms ease-in')),
  transition('none => visible', animate('200ms ease-out')),
]);

@Component({
  selector: 'app-scanner-companies',
  standalone: false,
  templateUrl: './scanner-companies.component.html',
  styleUrl: './scanner-companies.component.scss',
  animations: [toggleArrow],
})
export class ScannerCompaniesComponent {
  @Input() companies: any[] = [];
  @Input() side: 'ssp' | 'dsp' = 'ssp';
  @Input() label = '';
  @Input() busy = false;
  @Input() endpointTpl: TemplateRef<{ $implicit: any }>;
  @Input() headerTpl: TemplateRef<void> | null = null;

  private state: { [companyId: number]: boolean } = {};

  protected onToggleState(companyId: number): void {
    this.state[companyId] = !this.state[companyId];
  }

  protected isClosed(companyId: number): 'visible' | 'none' {
    return this.state[companyId] ? 'visible' : 'none';
  }

  protected trackByFn(index: number, item: { id?: number }): number {
    if (item.id) {
      return item.id;
    }
    return index;
  }
}
